'use client';

import './globals.css';
import { ErrorSurface } from '@/components/layout/error-surface';
import { useI18n } from '@/lib/i18n';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string; componentStack?: string };
  reset: () => void;
}) {
  const { language } = useI18n();

  // Fehler in Konsole ausgeben für Diagnose
  // eslint-disable-next-line no-console
  console.error('[GlobalError] React error:', error?.message, '\nStack:', error?.stack, '\nComponent Stack:', error?.componentStack, '\nDigest:', error?.digest);

  return (
    <html lang={language}>
      <body className="bg-background text-foreground antialiased">
        <ErrorSurface
          title="Anwendung musste in den Global-Fallback wechseln"
          message="Ein Fehler ist vor dem normalen Layout aufgetreten. Der Beschaffungsagenten-Client bleibt deshalb in einem globalen Sicherheits-Fallback und kann von hier aus neu initialisiert werden."
          error={error}
          onRetry={reset}
          fullScreen
        />
        {process.env.NODE_ENV !== 'production' || true ? (
          <pre style={{ position: 'fixed', bottom: 0, left: 0, right: 0, maxHeight: '200px', overflow: 'auto', background: '#1a1a2e', color: '#e94560', fontSize: '11px', padding: '8px', zIndex: 9999, margin: 0 }}>
            {error?.message}\n{error?.componentStack ?? error?.stack}
          </pre>
        ) : null}
      </body>
    </html>
  );
}